<script setup>
const gsapTimeline = useGsapTimeline()
const maskOne = ref(null)
const slot = ref(null)

const start = async () => {
  await gsapTimeline({ name: 'To Full Top Left' })
    .fromTo(maskOne, { translateX: '22%', translateY: '22%' }, { translateX: '-30%', translateY: '-40%', ease: 'power1.inOut', duration: 2 }, '>')
    .fromTo(slot, { opacity: 0 }, { opacity: 1, duration: 0.2 }, '<1')
}

defineExpose({ start })
</script>

<template>
  <div class="w-full h-full">
    <div ref="slot" class="w-full h-full z-10">
      <slot />
    </div>
    <div ref="maskOne" class="w-[400%] h-[400%] mask-one bg-willy-cr-gray-alt absolute top-0 left-0 z-20">
      <div class="mask-two bg-willy-cr-black-primary absolute w-full h-full top-[850px] left-[850px]" />
    </div>
  </div>
</template>

<style>
.mask-one {
  mask: url('../../masks/willy-mask-rectangle.svg'), url('../../masks/willy-mask-rectangle.svg');
  mask-repeat: no-repeat, no-repeat;
  mask-size: cover, cover;
  mask-position: 0 0, 1600px 1600px;
  mask-composite: exclude;
  transform: translateX(22%) translateY(22%);
}

.mask-two {
  mask: url('../../masks/willy-mask-rectangle.svg'), url('../../masks/willy-mask-rectangle.svg');
  mask-repeat: no-repeat, no-repeat;
  mask-size: cover, cover;
  mask-position: 0 0, 850px 850px;
  mask-composite: exclude;
}
</style>
